import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useMutation } from 'react-apollo';
import { toast } from 'react-toastify';
import { UPSERT_SPECIALTY_CATEGORY } from '../queries';

const AddEditCategoryModal = ({ isOpen, toggle, isEdit, category }) => {
  const [name, setName] = useState('');
  const [iconFile, setIconFile] = useState(null);

  useEffect(() => {
    if (!isOpen) return;

    if (category) {
      setName(category.specialty);
      return;
    }

    setName('');
    setIconFile(null);
  }, [category, isOpen]);

  const [upsertCategory, { loading }] = useMutation(UPSERT_SPECIALTY_CATEGORY, {
    refetchQueries: ['GET_SPECIALIZATION_MAPPING']
  });

  const handleSave = async () => {
    try {
      await upsertCategory({
        variables: {
          oldSpecialty: isEdit ? category.specialty : null,
          specialty: name,
          iconFile: iconFile || null
        }
      });

      toast.success(
        `${isEdit ? 'Updated' : 'Added'} category ${name} successfully`,
        { autoClose: 3000 }
      );

      toggle();
    } catch (e) {
      toast.error('Something went wrong!', { autoClose: 3000 });
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {isEdit ? 'Edit Category' : 'Add Category'}
      </ModalHeader>

      <ModalBody>
        <div className="mapping-form">
          <div className="mapping-form-row">
            <label>Category Name</label>

            <input
              type="text"
              className="form-control"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="Enter category name"
            />
          </div>

          <div className="mapping-form-row">
            <label>Upload Icon</label>

            <input
              type="file"
              accept="image/*"
              onChange={e => setIconFile(e.target.files[0])}
            />

            {iconFile && (
              <small style={{ display: 'block', marginTop: 5 }}>
                {iconFile.name}
              </small>
            )}
          </div>
        </div>
      </ModalBody>

      <ModalFooter className="mapping-modal-footer">
        <Button
          className="mapping-save-btn"
          disabled={loading || !name || !iconFile}
          onClick={handleSave}
        >
          Save
        </Button>

        <Button className="mapping-cancel-btn" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AddEditCategoryModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  isEdit: PropTypes.bool,
  category: PropTypes.object
};

export default AddEditCategoryModal;
